import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useEffect } from "react"

/**
 * If the last navigation Action was a POP Event then the redirect will execute a replace with a custom action
 * @param {*} param0
 * @returns
 */
export const Redirect = ({ to, animation, replace }) => {
	const { push, replace: repl, action } = useCustomNavigation()

	useEffect(() => {
		if (replace) {
			repl(to, animation)
		} else {
			if (action === "PUSH") {
				push(to, animation)
			} else if (action === "POP") {
				repl(to, animation, {}, "POP")
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return null
}
